<script>

   import * as testContents from '../configs/testItems.json';
   import * as conversions from '../configs/conversions.json';

   export let statsDict;
</script>

<ul>
   {#each Object.entries(statsDict) as [label,val]}
      {@const currentSectionInfo = testContents.default.filter(section => section.heading === label)[0]}
      {@const min = Math.min(...currentSectionInfo.classes.map(rangeInfo => rangeInfo.min))}
      {@const max = Math.max(...currentSectionInfo.classes.map(rangeInfo => rangeInfo.max))}
      <li class='bar-group'>
         <h3 class='float-end'>{val} / {max}</h3>
         <h3>{label}</h3>
         <div class="progress shadow bg-dark">
            <div style='width:{50 + 0.95 * (100 * val / max - 50)}%; --colorista: var(--{currentSectionInfo.color});' class="progress-bar progress-bar-striped shadow-sm" role="progressbar" aria-valuenow="{val}" aria-valuemin="{min}" aria-valuemax="{max}"></div>
         </div>
         <div class='d-flex justify-content-between'>
            {#each currentSectionInfo.classes as rangeInfo}
               <small class:boldest={rangeInfo.min <= val && val <= rangeInfo.max}>{conversions.default[rangeInfo.abbreviation]} (&thinsp;{rangeInfo.abbreviation.toUpperCase()}&thinsp;)</small>
            {/each}
         </div>
      </li>
   {/each}
</ul>

<style>
   ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
      text-align: left;
   }
   .bar-group {
      padding: 1rem 0;
   }
   .boldest {
      font-weight: 800;
   }
   .progress {
      background-image: linear-gradient(to bottom,black,transparent 50%);
   }
   .progress > .progress-bar {
      background-color: var(--colorista);
      box-shadow: 0 0 0.125rem 0 var(--colorista) , inset 0 -1.5rem 1rem -1.25rem #ffffff40, inset 0 0.5rem 0.5rem -0.5rem #ffffff80 , inset 0 3px 1px -2px #ffffff80 , inset 0 -3px 1px -2px #00000080 !important;
      margin: 0.25rem;
      border-radius: 0.25rem;
      animation: fill-up 0.375s ease-out;
      animation-delay: 0.125s;
      animation-fill-mode: both;
   }
   @keyframes fill-up {
      from {
         width: 0;
      }
   }
</style>